<section #weekRef class="flex relative w-full">
    @for (day of days(); track $index) {
        @if (day) {
            <div
                class="day-wrapper relative"
                [class.weekend]="$index === 6 || $index === 0"
                dndDropzone
                dndDragoverClass="drag-over"
                (dndDrop)="drop($event, day)"
            >
                <app-day
                    [day]="day"
                    [height]="height() || 200"
                    class="hidden md:block"
                    [overflowCountForDay]="overflowCountForDay(day)"
                    (more)="handleMore(day)"
                />
                <app-day [day]="day" [height]="60" class="md:hidden" />
            </div>
        }
    }

    @defer (on timer(200ms)) {
        @for (event of realRenderEvents(); track event.id) {
            <app-block-calendar-event
                #eventRef
                class="hidden calendar-event-container md:block"
                (menu)="handleEventMenu($event, event)"
                [days]="days()"
                [event]="event"
                [index]="$index"
                [weekIndex]="index()"
                [width]="width() / 7"
            />
        }
    }
</section>
